import { PendingNoteChange } from "./ursOfferNotesSlice"

const DB_NAME = 'ursOfferNotes'
const DB_VERSION = 1
const STORE_NAME = 'pendingChanges'

type DocRecord = { docId: number; changes: Record<string, PendingNoteChange> }

let dbPromise: Promise<IDBDatabase> | null = null

function openDb(): Promise<IDBDatabase> {
    if (dbPromise) return dbPromise
    dbPromise = new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION)
        request.onupgradeneeded = (event) => {
            const db = (event.target as IDBOpenDBRequest).result
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: 'docId' })
            }
        }
        request.onsuccess = (event) => resolve((event.target as IDBOpenDBRequest).result)
        request.onerror = (event) => reject((event.target as IDBOpenDBRequest).error)
    })
    return dbPromise
}

export async function getPendingChanges(docId: number): Promise<PendingNoteChange[]> {
    const db = await openDb()
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readonly')
        const request = tx.objectStore(STORE_NAME).get(docId)
        request.onsuccess = () => {
            const record: DocRecord | undefined = request.result
            resolve(record ? Object.values(record.changes) : [])
        }
        request.onerror = () => reject(request.error)
    })
}

export async function putPendingChange(docId: number, change: PendingNoteChange): Promise<void> {
    const db = await openDb()
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readwrite')
        const store = tx.objectStore(STORE_NAME)
        const getRequest = store.get(docId)
        getRequest.onsuccess = () => {
            const existing: DocRecord | undefined = getRequest.result
            const record: DocRecord = existing ?? { docId, changes: {} }
            record.changes[change.blockKey] = change
            const putRequest = store.put(record)
            putRequest.onsuccess = () => resolve()
            putRequest.onerror = () => reject(putRequest.error)
        }
        getRequest.onerror = () => reject(getRequest.error)
    })
}

export async function clearPendingChanges(docId: number): Promise<void> {
    const db = await openDb()
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readwrite')
        const request = tx.objectStore(STORE_NAME).delete(docId)
        request.onsuccess = () => resolve()
        request.onerror = () => reject(request.error)
    })
}
